import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MembersList from './MembersList';
import MembersForm from './MembersForm';
import MemberView from './MemberView';

const Members = () => {
  return (
    <Routes>
      <Route index element={<MembersList />} />
      <Route path="add" element={<MembersForm />} />
      <Route path="edit/:id" element={<MembersForm />} />
      <Route path="view/:id" element={<MemberView />} />
      <Route path="*" element={<Navigate to="/members" replace />} />
    </Routes>
  );
};

export default Members;